<template>
  <div class="listConfigCards" tabindex="0">
    <p v-show="cardData.length == 0" v-html="dataBO.cfg_msg_no_result"></p>
    <ConfigCard
      v-for="(item, i) in cardData"
      :key="i"
      :checkboxField="'cfgCard' + i"
      :checkboxLabel="handleCardTitle(item, isMotorCard)"
      :carSpecs="[item.fuel, item.transmission]"
      :carPrice="item.price"
      :carID="item.modelID"
      :objectID="item.id"
      :rent="item.rent"
      :taeg="item.taeg"
      :selectedEngine="isMotorCard ? item.engineID : null"
      :itemObj="item"
      :checkBoxChecked="handleCheckboxState(i, item.id)"
    >
      <p class="btn-tertiary" @click="openModal(item.lst)">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-arrow-right"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
          />
        </svg>
        {{ isMotorCard ? linkText[0] : linkText[1] }}
      </p>
    </ConfigCard>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapState } from "vuex";
import ConfigCard from "../../Cards/ConfigCard/ConfigCard.vue";

export default {
  name: "ListConfigCards",
  components: {
    ConfigCard,
  },
  props: {
    cardData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isMotorCard: { type: Boolean, default: true },
    selectedOption: { type: [Number, String] },
  },
  inject: ["page"],
  data() {
    return {
      linkText: ["Ver dados técnicos do motor", "Ver lista de equipamentos"],
    };
  },
  computed: {
    ...mapState(["dataBO"]),
    ...mapGetters({
      getEquipment: "versionsData/getModelEquips",
    }),
  },
  methods: {
    ...mapMutations({
      handleModalContent: "modalData/UPDATE_MODALSTATE",
      updateResumeState: "resumeData/UPDATE_STATE",
    }),
    openModal(lst) {
      if (this.page == "Motor") {
        this.handleModalContent({
          openModal: true,
          component: "ConfigCardModalContent",
          content: this.setEngineLstArr(lst),
          title: "Dados Técnicos do Motor",
        });
      } else if (this.page == "Version") {
        this.handleModalContent({
          openModal: true,
          component: "ConfigCardModalContent",
          content: this.getEquipment(lst),
          title: "Lista de equipamentos ",
        });
      }
      document.body.classList.add("isActive");
    },
    handleCardTitle(item, isEngineTitle) {
      let engine = item.engine;

      // require version title
      if (!isEngineTitle) return item.designation.replace(item.engine, "");

      // require engine title
      if (item.powerKw && item.electricMotor)
        engine += ` ( ${item.powerKw} Kw )`;
      if (item.power && !item.electricMotor) engine += ` ( ${item.power} CV )`;

      return engine;
    },
    setEngineLstArr(paramArr) {
      let motor = [];
      let perfAmb = [];

      paramArr.filter((el) => {
        if (el.idType == 1) {
          motor.push(el);
          return;
        }
        if (el.idType == 26) {
          perfAmb.push(el);
          return;
        }
      });

      let _array = [
        { title: "Motor", details: motor },
        { title: "Performance ambiental", details: perfAmb },
      ];
      return _array;
    },
    handleCheckboxState(i, id) {
      let numID = this.selectedOption;
      if (numID) return numID == id ? true : false;
      return i == 0 ? true : false;
    },
  },
};
</script>
<style lang="scss">
@import "./ListConfigCards.scss";
</style>
